import { useAppState } from "@contexts/app-state";
import RouteResolver from "@/routes";
import { globalCss } from "@stitches/react";

const globalStyles = globalCss({
  ".fe_f_all .fe_c_toast__header": {
    whiteSpace: "wrap !important",
  },
  ".fe_f_all .fe_c_multiselect__control": {
    whiteSpace: "nowrap",
  },
  ".fe_f_all .fe_c_multiselect__menu": {
    minWidth: 200,
  },
  ".fe_f_all ul.fe_c_tabs__labels": {
    border: "none",
  },
  ".fe_f_all .fe_c_tabs__shadow": {
    boxShadow: "none !important",
  },
  ".fe_f_all .fe_c_table--medium thead th": {
    padding: "16px 12px",
  },
  ".fe_f_all .fe_c_table--medium tbody td.fe_c_table__cell": {
    padding: "8px 12px",
  },
  ".fe_f_all table": {
    borderCollapse: "collapse",
    border: "1px solid #B6B7B7",
    width: "100%",
  },
  ".fe_f_all table th.fe_c_table__header--no-wrap": {
    maxWidth: "none",
  },
  ".fe_f_all table th, .fe_f_all table td": {
    border: "1px solid #B6B7B7",
  },
  ".fe_f_all .fe_c_table.fe_c_table--compact tbody td.fe_c_table__cell": {
    padding: "8px 12px",
  },
  ".fe_f_all .fe_c_table.fe_c_table--compact thead th.fe_c_table__header": {
    padding: "8px 12px",
  },
  ".fe_f_all table.fe_c_table.fe_c_table--show-hover.fe_c_table--compact th:first-child, .fe_f_all table td.fe_c_table__cell:first-child":
    {
      borderLeft: "none",
      paddingRight: 0,
    },
});

function App() {
  const { isFetchingContext, context } = useAppState();
  const currentEHR = context?.currentEHR ?? "athena";
  globalStyles();

  return (
    <div className="App">
      {isFetchingContext ? (
        <p>Loading...</p>
      ) : (
        <RouteResolver ehr={currentEHR} />
      )}
    </div>
  );
}
export default App;
